import { AxiosResponse, AxiosRequestConfig } from 'axios';

import client from 'api/client';
import { DocPayload } from '../models/payload';
import { AppDocument } from '../models/response';

export function get(
    application_id: string,
    document_id: string,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<AppDocument>> {
    return client.get<AppDocument>(
        `document-properties/${application_id}/${document_id}`,
        customConfig
    );
}

export function post(
    application_id: string,
    payload: DocPayload,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<{ msg: string }>> {
    return client.post<{ msg: string }>(
        `document-properties/${application_id}`,
        payload,
        customConfig
    );
}

export function put(
    application_id: string,
    document_id: string,
    payload: DocPayload,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<{ msg: string }>> {
    return client.put<{ msg: string }>(
        `document-properties/${application_id}/${document_id}`,
        payload,
        customConfig
    );
}

export function patch(
    application_id: string,
    document_id: string,
    payload: { [key in keyof AppDocument]?: AppDocument[key] },
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<{ msg: string }>> {
    return client.patch<{ msg: string }>(
        `document-properties/${application_id}/${document_id}`,
        payload,
        customConfig
    );
}

export function del(
    application_id: string,
    document_id: string,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<{ msg: string }>> {
    return client.delete<{ msg: string }>(
        `document-properties/${application_id}/${document_id}`,
        customConfig
    );
}
